export interface NonEmailCampaignStep {
  // No title found here since it is passed back via the details endpoint
  title?: string;
  icon: {
    name: string;
    color: string;
  };
  description: string;
}

export const NonEmailCampaignSteps: { [key: string]: NonEmailCampaignStep } = {
  'snapshot-creation': {
    icon: {
      name: 'note_add',
      color: '#512C8C',
    },
    description:
      'Create or refresh the Snapshot Report if it is older than 30 days. <br/> There is no email to preview for this event.',
  },
};
